import React from 'react';
import { ClassAssembly5C2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly5C2026 />;
  };
  
  export default ClassAssemblyPage;